module.exports = __webpack_public_path__ + "img/爸爸.96f8b5f3.png";